module.exports = __webpack_public_path__ + "img/email.aaa63720.svg";